export const credentials_en = {
  sesLoading: "Loading domain status…",
  sesEmptyTitle: "No sending domain yet",
  sesEmptyDesc:
    "Add a domain in Edit to send from your own brand and land in more inboxes.",
  sesAuthTitle: "Authenticate your sending domain",
  sesAuthDesc:
    "Add these records at your DNS provider (Cloudflare, GoDaddy, and the like). This confirms you own {domain} and keeps your email out of spam.",
  sesDnsRecords: "DNS records",
  sesColType: "Type",
  sesColName: "Name",
  sesColValue: "Value",
  sesCopyAll: "Copy all",
  sesVerifyDomain: "Verify domain",
  sesVerifyNote:
    "DNS changes can take a few minutes to appear — you can leave and come back.",
  sesStatusVerified: "Verified",
  sesStatusPending: "Pending",
  sesStatusFailed: "Failed",
  sesSetupDesc:
    "Authenticate {domain} so your email sends from your own brand and lands in more inboxes. We'll generate the DNS records you need to add.",
  sesGetRecords: "Get DNS records",
  sesProvisionFailed: "Couldn't start domain setup. Please try again.",
  sesLoadErrorTitle: "Couldn't load domain status",
  sesLoadErrorDesc:
    "We couldn't reach the server. Check your connection and try again.",
  sesRetry: "Retry",
  sesCheckConfirmed: "Confirmed",
  sesCheckPending: "Waiting for DNS",
  sesCheckFailed: "Failed",
  sesGroupDkim: "DKIM authentication",
  sesGroupDkimDesc:
    "Three CNAME records that let Amazon SES sign your email so inboxes trust it.",
  sesGroupOwnership: "Domain ownership",
  sesGroupOwnershipDesc:
    "One TXT record that proves this domain belongs to you.",
  sesVerifyWaitingDkim:
    "Your records are live. Amazon is still confirming DKIM — this usually takes a few minutes but can take up to 48 hours. You can leave and come back.",
  sesVerifyWaitingOwnership:
    "DKIM is confirmed. We can't see your ownership TXT record yet — double-check the _pubrio TXT record and give DNS a few minutes.",
  sesVerifiedMsg: "{domain} is verified and ready to send.",
  sesDomainVerified: "Domain verified — you're ready to send.",
  sesVerifyFailed: "Couldn't check verification. Please try again.",
  sesCopied: "Copied to clipboard.",
  sesCopiedAll: "All records copied.",
  sendingDomainSelectPlaceholder: "Select a verified sending domain",
  sendingDomainNoneVerified: "No verified domains yet — add one below",
  sendingDomainStatus_verified: "Verified",
  sendingDomainStatus_pending: "Pending",
  sendingDomainStatus_failed: "Failed",
  sendingDomainViewRecords: "View DNS records",
  sendingDomainDnsHint:
    "Add these CNAME records to your DNS, then click Verify:",
  sendingDomainCopy: "Copy",
  sendingDomainVerify: "Verify",
  sendingDomainAddPlaceholder: "yourdomain.com",
  sendingDomainAdd: "Add domain",
  sendingDomainAddFailed: "Could not add domain",
  sendingDomainVerified: "Domain verified",
  sendingDomainNotYet: "Not verified yet — DNS may still be propagating",
  sendingDomainVerifyFailed: "Verification check failed",
  sendingDomainCopied: "Copied",
  sequence_credentials_aside_create_new: "Create a credential",
  sequence_credentials_setting_title: "Credential settings",
  save_changes: "Save changes",
  sequence_credential_create_dialog_title: "Set Up New Credentials",
  sequence_credentials_create_dialog_empty:
    "Let’s get you connected—choose an account type and integration method above",
  sequence_credential_create_dialog_bottom_info:
    "Please authenticate before saving.",
  authenticate: "Authenticate",
  sequence_credential_create_dialog_common_name_label: "Credential Name",
  sequence_credential_create_dialog_common_channel_type_label: "Channel type",
  sequence_credential_create_dialog_common_authentication_type_label:
    "Integration method",
  sequence_credential_main_empty_title: "Connect Your Account to Get Started",
  sequence_credential_main_empty_description:
    "To start automating your outreach, link an account. This allows us to send messages, manage connections, and perform actions on your behalf.",
  sequence_credential_main_empty_button: "Link account",
  sequence_credentail_aside_empty_description: "Nothing here yet",
  sequence_credential_authentication_title: "Authentication",
  sequence_credential_authentication_description:
    "This account is linked for sending messages and actions. You can edit, reauthorize, or remove it anytime.",
  sequence_credentials_masked: "Credentials are masked",
  credential_empty_title: "All set!",
  credential_empty_desc:
    "This credential type is preconfigured. You’ll only need to update it if your access token changes",
  sequence_credential_inactive: "Inactive",
  sequence_credential_domain_unverified: "Domain not verified",
};

export const credentials_zh_tw = {
  sequence_credentials_aside_create_new: "建立憑證",
  sequence_credentials_setting_title: "憑證設定",
  save_changes: "儲存變更",
  sequence_credential_create_dialog_title: "設定新憑證",
  sequence_credentials_create_dialog_empty:
    "讓我們來建立連線—請在上方選擇帳戶類型與整合方式",
  sequence_credential_create_dialog_bottom_info: "請先完成驗證後再儲存。",
  authenticate: "驗證",
  sequence_credential_create_dialog_common_name_label: "憑證名稱",
  sequence_credential_create_dialog_common_channel_type_label: "通道類型",
  sequence_credential_create_dialog_common_authentication_type_label:
    "整合方式",
  sequence_credential_main_empty_title: "連接帳戶以開始使用",
  sequence_credential_main_empty_description:
    "若要開始自動化拓展流程，請連結帳戶。這將允許我們代表您傳送訊息、管理連結並執行操作。",
  sequence_credential_main_empty_button: "連結帳戶",
  sequence_credentail_aside_empty_description: "這裡還沒有內容",
  sequence_credential_authentication_title: "驗證資訊",
  sequence_credential_authentication_description:
    "此帳戶已連結以執行訊息傳送與操作。您可以隨時編輯、重新授權或移除。",
  sequence_credentials_masked: "憑證已隱藏",
  credential_empty_title: "一切準備就緒！",
  credential_empty_desc: "此憑證類型已預先設定，僅在存取權杖變更時需要更新。",
  sesLoading: "正在載入網域狀態…",
  sesEmptyTitle: "尚未設定寄件網域",
  sesEmptyDesc: "在「編輯」中新增網域，即可使用您自己的品牌寄件並提升送達率。",
  sesAuthTitle: "驗證您的寄件網域",
  sesAuthDesc:
    "請在您的 DNS 服務商（如 Cloudflare、GoDaddy）新增以下記錄。這可確認您擁有 {domain} 並避免郵件被歸為垃圾郵件。",
  sesDnsRecords: "DNS 記錄",
  sesColType: "類型",
  sesColName: "名稱",
  sesColValue: "值",
  sesCopyAll: "全部複製",
  sesVerifyDomain: "驗證網域",
  sesVerifyNote: "DNS 變更可能需要幾分鐘才會生效—您可以稍後再回來。",
  sesStatusVerified: "已驗證",
  sesStatusPending: "待驗證",
  sesStatusFailed: "失敗",
  sesSetupDesc:
    "驗證 {domain}，即可使用您自己的品牌寄件並提升送達率。我們會為您產生需要新增的 DNS 記錄。",
  sesGetRecords: "取得 DNS 記錄",
  sesProvisionFailed: "無法開始網域設定，請再試一次。",
  sesLoadErrorTitle: "無法載入網域狀態",
  sesLoadErrorDesc: "我們無法連線到伺服器，請檢查您的網路連線後再試一次。",
  sesRetry: "重試",
  sesCheckConfirmed: "已確認",
  sesCheckPending: "等待 DNS",
  sesCheckFailed: "失敗",
  sesGroupDkim: "DKIM 驗證",
  sesGroupDkimDesc:
    "三筆 CNAME 記錄，讓 Amazon SES 為您的郵件簽章，提升收件匣的信任度。",
  sesGroupOwnership: "網域擁有權",
  sesGroupOwnershipDesc: "一筆 TXT 記錄，用以證明此網域屬於您。",
  sesVerifyWaitingDkim:
    "您的記錄已生效。Amazon 仍在確認 DKIM—通常需要幾分鐘，最長可能需要 48 小時。您可以稍後再回來。",
  sesVerifyWaitingOwnership:
    "DKIM 已確認。我們尚未偵測到您的擁有權 TXT 記錄—請再次確認 _pubrio TXT 記錄，並稍候幾分鐘讓 DNS 生效。",
  sesVerifiedMsg: "{domain} 已驗證，可以開始寄件。",
  sesDomainVerified: "網域已驗證—您可以開始寄件了。",
  sesVerifyFailed: "無法檢查驗證狀態，請再試一次。",
  sesCopied: "已複製到剪貼簿。",
  sesCopiedAll: "已複製所有記錄。",
  sequence_credential_domain_unverified: "網域未驗證",

  sequence_credential_inactive: "失效",
};
export const credentials_zh_cn = {
  sequence_credentials_aside_create_new: "创建凭证",
  sequence_credentials_setting_title: "凭证设置",
  save_changes: "保存更改",
  sequence_credential_create_dialog_title: "设置新凭证",
  sequence_credentials_create_dialog_empty:
    "让我们开始连接——请在上方选择账户类型和集成方式",
  sequence_credential_create_dialog_bottom_info: "请先完成身份验证再保存。",
  authenticate: "验证",
  sequence_credential_create_dialog_common_name_label: "凭证名称",
  sequence_credential_create_dialog_common_channel_type_label: "渠道类型",
  sequence_credential_create_dialog_common_authentication_type_label:
    "集成方式",
  sequence_credential_main_empty_title: "连接您的账户以开始使用",
  sequence_credential_main_empty_description:
    "要开始自动化您的外联流程，请先连接一个账户。这将允许我们代表您发送消息、管理联系人并执行操作。",
  sequence_credential_main_empty_button: "连接账户",
  sequence_credentail_aside_empty_description: "这里还没有内容",
  sequence_credential_authentication_title: "身份验证",
  sequence_credential_authentication_description:
    "该账户已连接，可用于发送消息和执行操作。您可以随时编辑、重新授权或移除。",
  sequence_credentials_masked: "凭证已隐藏",
  credential_empty_title: "一切就绪！",
  credential_empty_desc: "此凭证类型已预配置，仅在访问令牌更改时需要更新。",
  sesLoading: "正在加载域名状态…",
  sesEmptyTitle: "尚未设置发件域名",
  sesEmptyDesc: "在「编辑」中添加域名，即可使用您自己的品牌发件并提升送达率。",
  sesAuthTitle: "验证您的发件域名",
  sesAuthDesc:
    "请在您的 DNS 服务商（如 Cloudflare、GoDaddy）添加以下记录。这可确认您拥有 {domain} 并避免邮件被归为垃圾邮件。",
  sesDnsRecords: "DNS 记录",
  sesColType: "类型",
  sesColName: "名称",
  sesColValue: "值",
  sesCopyAll: "全部复制",
  sesVerifyDomain: "验证域名",
  sesVerifyNote: "DNS 更改可能需要几分钟才会生效—您可以稍后再回来。",
  sesStatusVerified: "已验证",
  sesStatusPending: "待验证",
  sesStatusFailed: "失败",
  sesSetupDesc:
    "验证 {domain}，即可使用您自己的品牌发件并提升送达率。我们会为您生成需要添加的 DNS 记录。",
  sesGetRecords: "获取 DNS 记录",
  sesProvisionFailed: "无法开始域名设置，请重试。",
  sesLoadErrorTitle: "无法加载域名状态",
  sesLoadErrorDesc: "我们无法连接到服务器，请检查您的网络连接后重试。",
  sesRetry: "重试",
  sesCheckConfirmed: "已确认",
  sesCheckPending: "等待 DNS",
  sesCheckFailed: "失败",
  sesGroupDkim: "DKIM 验证",
  sesGroupDkimDesc:
    "三条 CNAME 记录，让 Amazon SES 为您的邮件签名，提升收件箱的信任度。",
  sesGroupOwnership: "域名所有权",
  sesGroupOwnershipDesc: "一条 TXT 记录，用于证明此域名属于您。",
  sesVerifyWaitingDkim:
    "您的记录已生效。Amazon 仍在确认 DKIM—通常需要几分钟，最长可能需要 48 小时。您可以稍后再回来。",
  sesVerifyWaitingOwnership:
    "DKIM 已确认。我们尚未检测到您的所有权 TXT 记录—请再次确认 _pubrio TXT 记录，并稍候几分钟让 DNS 生效。",
  sesVerifiedMsg: "{domain} 已验证，可以开始发件。",
  sesDomainVerified: "域名已验证—您可以开始发件了。",
  sesVerifyFailed: "无法检查验证状态，请重试。",
  sesCopied: "已复制到剪贴板。",
  sesCopiedAll: "已复制所有记录。",
  sequence_credential_domain_unverified: "域名未验证",

  sequence_credential_inactive: "失效",
};

export const credentialsJapanese = {
  sequence_credentials_aside_create_new: "認証情報を作成",
  sequence_credentials_setting_title: "認証情報設定",
  save_changes: "変更を保存",
  sequence_credential_create_dialog_title: "新しい認証情報を設定",
  sequence_credentials_create_dialog_empty:
    "接続を確立しましょう—上記でアカウントタイプと統合方法を選択してください",
  sequence_credential_create_dialog_bottom_info: "保存前に認証を完了してください。",
  authenticate: "認証",
  sequence_credential_create_dialog_common_name_label: "認証情報名",
  sequence_credential_create_dialog_common_channel_type_label: "チャネルタイプ",
  sequence_credential_create_dialog_common_authentication_type_label:
    "統合方法",
  sequence_credential_main_empty_title: "アカウントを接続して開始",
  sequence_credential_main_empty_description:
    "自動化プロセスを開始するには、アカウントをリンクしてください。これにより、メッセージ送信、リンク管理、操作実行が可能になります。",
  sequence_credential_main_empty_button: "アカウントをリンク",
  sequence_credentail_aside_empty_description: "ここにはまだ何もありません",
  sequence_credential_authentication_title: "認証情報",
  sequence_credential_authentication_description:
    "このアカウントはメッセージ送信と操作実行のために接続されています。編集、再認証、削除はいつでも可能です。",
  sequence_credentials_masked: "認証情報はマスクされています",
  credential_empty_title: "準備が完了しました！",
  credential_empty_desc: "この認証情報タイプは事前設定済みで、アクセストークン変更時のみ更新が必要です。",
  sesLoading: "ドメインの状態を読み込み中…",
  sesEmptyTitle: "送信ドメインがまだありません",
  sesEmptyDesc: "「編集」でドメインを追加すると、自社ブランドで送信でき、到達率が向上します。",
  sesAuthTitle: "送信ドメインを認証",
  sesAuthDesc:
    "DNSプロバイダー（Cloudflare、GoDaddyなど）で以下のレコードを追加してください。これにより {domain} の所有が確認され、メールが迷惑メールに振り分けられるのを防ぎます。",
  sesDnsRecords: "DNSレコード",
  sesColType: "タイプ",
  sesColName: "名前",
  sesColValue: "値",
  sesCopyAll: "すべてコピー",
  sesVerifyDomain: "ドメインを認証",
  sesVerifyNote: "DNSの変更が反映されるまで数分かかる場合があります—一度離れても大丈夫です。",
  sesStatusVerified: "認証済み",
  sesStatusPending: "保留中",
  sesStatusFailed: "失敗",
  sesSetupDesc:
    "{domain} を認証すると、自社ブランドで送信でき、到達率が向上します。追加が必要なDNSレコードを生成します。",
  sesGetRecords: "DNSレコードを取得",
  sesProvisionFailed: "ドメインの設定を開始できませんでした。もう一度お試しください。",
  sesLoadErrorTitle: "ドメインの状態を読み込めませんでした",
  sesLoadErrorDesc: "サーバーに接続できませんでした。接続を確認してもう一度お試しください。",
  sesRetry: "再試行",
  sesCheckConfirmed: "確認済み",
  sesCheckPending: "DNSを待機中",
  sesCheckFailed: "失敗",
  sesGroupDkim: "DKIM認証",
  sesGroupDkimDesc:
    "Amazon SESがメールに署名し、受信トレイの信頼性を高めるための3つのCNAMEレコードです。",
  sesGroupOwnership: "ドメイン所有権",
  sesGroupOwnershipDesc: "このドメインがあなたのものであることを証明する1つのTXTレコードです。",
  sesVerifyWaitingDkim:
    "レコードは有効です。AmazonがまだDKIMを確認中です—通常は数分、最大48時間かかる場合があります。一度離れても大丈夫です。",
  sesVerifyWaitingOwnership:
    "DKIMは確認済みです。所有権のTXTレコードをまだ検出できません—_pubrio TXTレコードを再確認し、DNSが反映されるまで数分お待ちください。",
  sesVerifiedMsg: "{domain} は認証され、送信可能です。",
  sesDomainVerified: "ドメインが認証されました—送信できます。",
  sesVerifyFailed: "認証を確認できませんでした。もう一度お試しください。",
  sesCopied: "クリップボードにコピーしました。",
  sesCopiedAll: "すべてのレコードをコピーしました。",
  sequence_credential_domain_unverified: "ドメイン未認証",

  sequence_credential_inactive: "無効"
};

export const credentialsKorean = {
  sequence_credentials_aside_create_new: "인증 정보 생성",
  sequence_credentials_setting_title: "인증 정보 설정",
  save_changes: "변경 사항 저장",
  sequence_credential_create_dialog_title: "새 인증 정보 설정",
  sequence_credentials_create_dialog_empty:
    "연결을 생성해 보세요—위에서 계정 유형과 통합 방식을 선택하세요",
  sequence_credential_create_dialog_bottom_info: "저장 전 인증을 완료해 주세요.",
  authenticate: "인증",
  sequence_credential_create_dialog_common_name_label: "인증 정보 이름",
  sequence_credential_create_dialog_common_channel_type_label: "채널 유형",
  sequence_credential_create_dialog_common_authentication_type_label:
    "통합 방식",
  sequence_credential_main_empty_title: "계정 연결하여 시작하기",
  sequence_credential_main_empty_description:
    "자동화 프로세스를 시작하려면 계정을 연결하세요. 이를 통해 메시지 전송, 링크 관리 및 작업 실행이 가능해집니다.",
  sequence_credential_main_empty_button: "계정 연결",
  sequence_credentail_aside_empty_description: "여기에 아직 내용이 없습니다",
  sequence_credential_authentication_title: "인증 정보",
  sequence_credential_authentication_description:
    "이 계정은 메시지 전송과 작업 실행을 위해 연결되었습니다. 언제든지 편집, 재인증 또는 제거할 수 있습니다.",
  sequence_credentials_masked: "인증 정보가 마스킹됨",
  credential_empty_title: "모든 준비가 완료되었습니다!",
  credential_empty_desc: "이 인증 정보 유형은 사전 설정되어 있으며 액세스 토큰 변경 시에만 업데이트가 필요합니다.",
  sesLoading: "도메인 상태를 불러오는 중…",
  sesEmptyTitle: "발신 도메인이 아직 없습니다",
  sesEmptyDesc: "「편집」에서 도메인을 추가하면 자체 브랜드로 발송하고 도달률을 높일 수 있습니다.",
  sesAuthTitle: "발신 도메인 인증",
  sesAuthDesc:
    "DNS 공급업체(Cloudflare, GoDaddy 등)에서 다음 레코드를 추가하세요. 이를 통해 {domain} 소유가 확인되고 이메일이 스팸으로 분류되는 것을 방지합니다.",
  sesDnsRecords: "DNS 레코드",
  sesColType: "유형",
  sesColName: "이름",
  sesColValue: "값",
  sesCopyAll: "모두 복사",
  sesVerifyDomain: "도메인 인증",
  sesVerifyNote: "DNS 변경 사항이 반영되는 데 몇 분 정도 걸릴 수 있습니다—나갔다가 다시 오셔도 됩니다.",
  sesStatusVerified: "인증됨",
  sesStatusPending: "대기 중",
  sesStatusFailed: "실패",
  sesSetupDesc:
    "{domain}을 인증하면 자체 브랜드로 발송하고 도달률을 높일 수 있습니다. 추가해야 할 DNS 레코드를 생성해 드립니다.",
  sesGetRecords: "DNS 레코드 가져오기",
  sesProvisionFailed: "도메인 설정을 시작할 수 없습니다. 다시 시도해 주세요.",
  sesLoadErrorTitle: "도메인 상태를 불러올 수 없습니다",
  sesLoadErrorDesc: "서버에 연결할 수 없습니다. 연결을 확인하고 다시 시도해 주세요.",
  sesRetry: "재시도",
  sesCheckConfirmed: "확인됨",
  sesCheckPending: "DNS 대기 중",
  sesCheckFailed: "실패",
  sesGroupDkim: "DKIM 인증",
  sesGroupDkimDesc:
    "Amazon SES가 이메일에 서명하여 받은편지함의 신뢰도를 높이는 3개의 CNAME 레코드입니다.",
  sesGroupOwnership: "도메인 소유권",
  sesGroupOwnershipDesc: "이 도메인이 귀하의 것임을 증명하는 1개의 TXT 레코드입니다.",
  sesVerifyWaitingDkim:
    "레코드가 적용되었습니다. Amazon이 아직 DKIM을 확인 중입니다—보통 몇 분, 최대 48시간이 걸릴 수 있습니다. 나갔다가 다시 오셔도 됩니다.",
  sesVerifyWaitingOwnership:
    "DKIM이 확인되었습니다. 소유권 TXT 레코드를 아직 찾을 수 없습니다—_pubrio TXT 레코드를 다시 확인하고 DNS가 적용될 때까지 몇 분 기다려 주세요.",
  sesVerifiedMsg: "{domain}이(가) 인증되어 발송할 준비가 되었습니다.",
  sesDomainVerified: "도메인이 인증되었습니다—발송할 수 있습니다.",
  sesVerifyFailed: "인증을 확인할 수 없습니다. 다시 시도해 주세요.",
  sesCopied: "클립보드에 복사되었습니다.",
  sesCopiedAll: "모든 레코드가 복사되었습니다.",
  sequence_credential_domain_unverified: "도메인 미인증",

  sequence_credential_inactive: "비활성화"
};

export const credentialsHindi = {
  sequence_credentials_aside_create_new: "क्रेडेंशियल बनाएं",
  sequence_credentials_setting_title: "क्रेडेंशियल सेटिंग",
  save_changes: "परिवर्तन सहेजें",
  sequence_credential_create_dialog_title: "नया क्रेडेंशियल सेट करें",
  sequence_credentials_create_dialog_empty:
    "आइए कनेक्शन बनाएं—कृपया ऊपर खाता प्रकार और एकीकरण विधि चुनें",
  sequence_credential_create_dialog_bottom_info: "सहेजने से पहले प्रमाणीकरण पूरा करें।",
  authenticate: "प्रमाणित करें",
  sequence_credential_create_dialog_common_name_label: "क्रेडेंशियल नाम",
  sequence_credential_create_dialog_common_channel_type_label: "चैनल प्रकार",
  sequence_credential_create_dialog_common_authentication_type_label:
    "एकीकरण विधि",
  sequence_credential_main_empty_title: "प्रारंभ करने के लिए खाता कनेक्ट करें",
  sequence_credential_main_empty_description:
    "ऑटोमेशन प्रक्रिया शुरू करने के लिए, कृपया एक खाता लिंक करें। यह हमें आपकी ओर से संदेश भेजने, लिंक प्रबंधित करने और क्रियाएं निष्पादित करने की अनुमति देगा।",
  sequence_credential_main_empty_button: "खाता लिंक करें",
  sequence_credentail_aside_empty_description: "यहां अभी तक कुछ नहीं है",
  sequence_credential_authentication_title: "प्रमाणीकरण जानकारी",
  sequence_credential_authentication_description:
    "यह खाता संदेश भेजने और क्रियाएं निष्पादित करने के लिए कनेक्ट किया गया है। आप कभी भी संपादित कर सकते हैं, पुनः प्रमाणित कर सकते हैं या हटा सकते हैं।",
  sequence_credentials_masked: "क्रेडेंशियल मास्क किए गए",
  credential_empty_title: "सब तैयार है!",
  credential_empty_desc: "इस क्रेडेंशियल प्रकार को पहले से कॉन्फ़िगर किया गया है और केवल एक्सेस टोकन बदलने पर अद्यतन की आवश्यकता होती है।",
  sesLoading: "डोमेन स्थिति लोड हो रही है…",
  sesEmptyTitle: "अभी तक कोई भेजने वाला डोमेन नहीं",
  sesEmptyDesc: "अपने ब्रांड से भेजने और अधिक इनबॉक्स तक पहुंचने के लिए «संपादित करें» में एक डोमेन जोड़ें।",
  sesAuthTitle: "अपना भेजने वाला डोमेन प्रमाणित करें",
  sesAuthDesc:
    "अपने DNS प्रदाता (Cloudflare, GoDaddy आदि) पर ये रिकॉर्ड जोड़ें। यह पुष्टि करता है कि {domain} आपका है और आपके ईमेल को स्पैम से बाहर रखता है।",
  sesDnsRecords: "DNS रिकॉर्ड",
  sesColType: "प्रकार",
  sesColName: "नाम",
  sesColValue: "मान",
  sesCopyAll: "सभी कॉपी करें",
  sesVerifyDomain: "डोमेन सत्यापित करें",
  sesVerifyNote: "DNS परिवर्तन दिखने में कुछ मिनट लग सकते हैं—आप बाद में वापस आ सकते हैं।",
  sesStatusVerified: "सत्यापित",
  sesStatusPending: "लंबित",
  sesStatusFailed: "विफल",
  sesSetupDesc:
    "{domain} को प्रमाणित करें ताकि आप अपने ब्रांड से भेज सकें और अधिक इनबॉक्स तक पहुंच सकें। हम आपके लिए आवश्यक DNS रिकॉर्ड तैयार करेंगे।",
  sesGetRecords: "DNS रिकॉर्ड प्राप्त करें",
  sesProvisionFailed: "डोमेन सेटअप शुरू नहीं हो सका। कृपया पुनः प्रयास करें।",
  sesLoadErrorTitle: "डोमेन स्थिति लोड नहीं हो सकी",
  sesLoadErrorDesc: "हम सर्वर से कनेक्ट नहीं हो सके। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।",
  sesRetry: "पुनः प्रयास करें",
  sesCheckConfirmed: "पुष्टि हो गई",
  sesCheckPending: "DNS की प्रतीक्षा है",
  sesCheckFailed: "विफल",
  sesGroupDkim: "DKIM प्रमाणीकरण",
  sesGroupDkimDesc:
    "तीन CNAME रिकॉर्ड जो Amazon SES को आपके ईमेल पर हस्ताक्षर करने देते हैं ताकि इनबॉक्स उन पर भरोसा करें।",
  sesGroupOwnership: "डोमेन स्वामित्व",
  sesGroupOwnershipDesc: "एक TXT रिकॉर्ड जो साबित करता है कि यह डोमेन आपका है।",
  sesVerifyWaitingDkim:
    "आपके रिकॉर्ड सक्रिय हैं। Amazon अभी भी DKIM की पुष्टि कर रहा है—इसमें आमतौर पर कुछ मिनट लगते हैं, लेकिन 48 घंटे तक लग सकते हैं। आप बाद में वापस आ सकते हैं।",
  sesVerifyWaitingOwnership:
    "DKIM की पुष्टि हो गई है। हम अभी तक आपका स्वामित्व TXT रिकॉर्ड नहीं देख पा रहे हैं—_pubrio TXT रिकॉर्ड दोबारा जांचें और DNS के लिए कुछ मिनट प्रतीक्षा करें।",
  sesVerifiedMsg: "{domain} सत्यापित है और भेजने के लिए तैयार है।",
  sesDomainVerified: "डोमेन सत्यापित—आप भेजने के लिए तैयार हैं।",
  sesVerifyFailed: "सत्यापन जांच नहीं सका। कृपया पुनः प्रयास करें।",
  sesCopied: "क्लिपबोर्ड पर कॉपी किया गया।",
  sesCopiedAll: "सभी रिकॉर्ड कॉपी किए गए।",
  sequence_credential_domain_unverified: "डोमेन असत्यापित",

  sequence_credential_inactive: "निष्क्रिय"
};